import Rails from '@rails/ujs'
Rails.start()

import '~/modules/recaptcha'
import '~/modules/webawesome'

// Controller Roots
import '~/controllers'
